import { useMutation } from 'react-query'
import { CreateCommentDto, useCommentCrud } from '../../api'
import { queryClient } from '../../react-query-provider'

export const useCreateComment = (discussionId: number) => {
  const { create } = useCommentCrud()

  return useMutation(({ dto }: { dto: CreateCommentDto }) => create(discussionId, dto), {
    onSuccess: () => {
      queryClient.invalidateQueries(['discussions', discussionId, 'comments'])
    }
  })
}
